<template>
  <div>
    <v-card outlined class="mb-2 pa-3">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-col cols="12">
          <v-row>
            <v-col>
              <v-text-field
                v-model="tempData.name"
                outlined
                :label="$ucfirst($t('myWeekMedicationDetail.name', { catalog: 'app_mobile' }))"
                required
                dense
                :rules="nameRules"
              ></v-text-field>
            </v-col>
            <v-col cols="4" align="right">
              <v-btn
                class="mr-3"
                fab
                text
                color="primary"
                @click="saveScheme()"
                :disabled="!valid"
              >
                <eva-icon name="save-outline"></eva-icon>
              </v-btn>
              <v-btn
                fab
                text
                color="error"
                @click="cancelAddingScheme()"
              >
                <eva-icon fill="red" name="trash-2-outline"></eva-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <p class="pt-2 mb-0">
                {{ $ucfirst($t('dss.startMedication')) }}
              </p>
            </v-col>
            <v-col>
              <v-select
                :items="medicationClassesToChooseFrom"
                outlined
                multiple
                :label="$ucfirst($t('dss.startMedicationClasses'))"
                required
                dense
                v-model="tempData.startMedicationClasses"
                item-text="name"
                :rules="medicationClassRules"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <p class="pt-2 mb-0">
                {{ $ucfirst($t('dss.additionalMedication')) }}
              </p>
            </v-col>
            <v-col>
              <v-select
                :items="medicationClassesToChooseFrom"
                outlined
                multiple
                :label="$ucfirst($t('dss.additionalMedicationClasses'))"
                required
                dense
                v-model="tempData.additionalMedicationClasses"
                item-text="name"
                :rules="medicationClassRules"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <p class="pt-2 mb-0">
                {{ $ucfirst($t('dss.description')) }}
              </p>
            </v-col>
            <v-col>
              <v-text-field
                v-model="tempData.description"
                outlined
                :label="$ucfirst($t('dss.description'))"
                required
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-form>
    </v-card>
    <v-dialog
      v-model="showDialog"
      width="600px"
    >
      <div class="dashboard-dialog-window">
        <div class="dashboard-dialog-window__message">
          {{
            this.$ucfirst(
                this.$t("dss.areYouSureToDeleteTitrationScheme", {
                  params: {
                    titrationSchemeName:
                        this.tempData.name ||
                        this.$ucfirst(
                            this.$t("dss.noName")
                        ),
                  },
                })
            )
          }}
        </div>
        <div class="dashboard-dialog-window__actions">
          <v-btn
              x-large
              text
              class="ml-4"
              @click="cancelAddingScheme"
          >
            {{ $ucfirst($t('confirm')) }}
          </v-btn>
          <v-btn
              x-large
              text
              class="ml-4"
              @click="showDialog = false"
              color="primary"
          >
            {{ $ucfirst($t('buttons.cancel', {catalog: 'app_mobile'})) }}
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
/**
 * Component AddDrugAdditionTitrationSchemeCard.vue
 *
 * @module AddDrugAdditionTitrationSchemeCard
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/components/Parts/DSS/AddDrugAdditionTitrationSchemeCard.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "AddDrugAdditionTitrationSchemeCard",
  props: {
    medicationClassesToChooseFrom: {
      type: Array,
    },
  },
  data: function () {
    return {
      showDialog: false,
      valid: true,
      editMode: false,
      tempData: {
        type: "DRUG_ADDITION",
        name: null,
        description: null,
        startMedicationClasses: [],
        additionalMedicationClasses: [],
      },
      nameRules: [(v) => !!v || this.$ucfirst(this.$t("validation.IS_REQUIRED"))],
      medicationClassRules: [
        (v) => v.length > 0 || this.$ucfirst(this.$t("validation.atLeastOneMedicationClass")),
      ],
    };
  },
  methods: {
    medicationClassesToString(medicationClassesArray) {
      const arrayToJoin = [];

      medicationClassesArray.forEach((medicationClass) => {
        arrayToJoin.push(medicationClass.name);
      });

      return arrayToJoin.join(", ");
    },
    saveScheme() {
      if (this.$refs.form.validate()) {
        const isNew = true;
        this.$emit("save-scheme", this.tempData, isNew);
      } else {
        console.log("THERE ARE ERRORS IN THE FORM");
      }
    },
    cancelAddingScheme() {
      if (!this.showDialog) {
        this.showDialog = true;
      } else {
        this.$emit("cancel-adding-scheme");
        this.showDialog = false;
      }
    },
    setInputWatchers() {
      const keys = Object.keys(this.tempData);
      keys.forEach((key) => {
        this.$watch(`tempData.${key}`, {
          deep: true,
          handler: function(current) {
            const data = {
              unsavedChanges: true,
              screen: 'titrationSchemes',
              name: `addTitrationScheme-newDrug`
            }
            this.$store.dispatch('patientSummary/toggleMultipleUnsavedChanges', data);
          }
        })
      })
    }
  },
  mounted() {
    this.setInputWatchers();
  }
};
</script>

<style lang="scss">
@import "../../../../../scss/colors";
</style>